import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Termin } from '../../../entities/Termin';
import { TermineAccordion } from '@/domain/arbeitszeiten/pages/uebersicht/Termine/TermineAccordion';
import { TooltipPopoverTrigger } from '@/domain/arbeitszeiten/pages/uebersicht/Termine/TooltipPopoverTrigger';
import { cn } from '@/lib/utils';

export function TermineTooltip({
  termine,
}: {
  termine: {
    termine?: Termin[];
    error?: string;
  };
}) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger
          className={cn(
            'hidden lg:inline-flex',
            termine.termine.length < 1 && !termine.error
              ? 'cursor-auto'
              : 'cursor-pointer',
          )}>
          <TooltipPopoverTrigger termineCount={termine.termine.length} />
        </TooltipTrigger>
        {termine.termine.length > 0 && (
          <TooltipContent side="bottom" className="w-[400px]">
            <TermineAccordion termine={termine.termine} />
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
